import { render } from "./RequestsReceived.vue?vue&type=template&id=2cd97b2c&scoped=true"
import script from "./RequestsReceived.vue?vue&type=script&lang=js"
export * from "./RequestsReceived.vue?vue&type=script&lang=js"

import "./RequestsReceived.vue?vue&type=style&index=0&id=2cd97b2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cd97b2c"

export default script